
import React from 'react';
import { Button } from '../../../components/base/Button';

export const ProcessSection: React.FC = () => {
  const steps = [
    {
      number: '01',
      title: 'Warteliste beitreten',
      description: 'Tragen Sie sich in die Wunschliste ein und sichern Sie sich einen der 40 verfügbaren Plätze.',
      icon: 'ri-user-add-line'
    },
    {
      number: '02',
      title: 'Persönliches Gespräch',
      description: 'Wir melden uns bei Ihnen und überprüfen gemeinsam, ob Ihre Teilnahme möglich ist.',
      icon: 'ri-phone-line'
    },
    {
      number: '03',
      title: 'Exklusiver Start',
      description: 'Pro Postleitzahlgebiet und Branche nur ein Teilnehmer - Ihr Wettbewerbsvorteil.',
      icon: 'ri-shield-star-line'
    }
  ];

  const scrollToWarteliste = () => {
    const element = document.getElementById('warteliste');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="anmeldung" className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            So sichern Sie Ihre Teilnahme
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            In nur 3 einfachen Schritten zu Ihrer digitalen Transformation
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300 h-full">
                <div className="flex items-center mb-6">
                  <div className="w-12 h-12 bg-blue-600 text-white rounded-full flex items-center justify-center text-lg font-bold mr-4">
                    {step.number}
                  </div>
                  <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
                    <i className={`${step.icon} text-blue-600 text-xl`}></i>
                  </div>
                </div>
                
                <h3 className="text-xl font-bold text-gray-900 mb-4">
                  {step.title}
                </h3>
                
                <p className="text-gray-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
              
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                  <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center">
                    <i className="ri-arrow-right-line text-white"></i>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-green-600 to-blue-600 rounded-2xl p-8 text-white text-center">
          <h3 className="text-3xl font-bold mb-4">Bereit für die Transformation?</h3>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Werden Sie Teil einer exklusiven Gruppe von Unternehmern, die ihre Digitalisierung erfolgreich meistern.
          </p>
          <Button 
            onClick={scrollToWarteliste}
            variant="secondary"
            size="lg"
            className="bg-white text-gray-900 hover:bg-gray-100"
          >
            Jetzt Platz sichern
          </Button>
        </div>
      </div>
    </section>
  );
};
